export default "__VITE_ASSET__Gta0VA$r__"